import React, {useState, useEffect} from 'react';
import {get} from 'lodash';
import {gql} from 'apollo-boost';
import styled from 'styled-components';
import ReactHtmlParser from 'react-html-parser';
import GoogleMapReact from 'google-map-react';
import {Grid, Box} from '@material-ui/core';

import client from '../../src/graphql/client';
import {theme} from '../../src/themes/default-theme';
import refactorDealerData from '../../src/data-restructure/pages/dealer'
import seoQuery from '../../src/graphql/queries/seo';
import contentBuilderQuery from '../../src/graphql/queries/content-builder';
import refactorHb from '../../src/data-restructure/multimedia/hero-banner';
import refactorBreadcrumbsData from '../../src/data-restructure/navigation/breadcrumbs/breadcrumbs';
import financeRatesQuery from '../../src/graphql/queries/finance-rates';
import financeRatesRestructure from '../../src/data-restructure/data/repayment-calc-rates';


// components
import Banner from '../../src/components/multimedia/Banner';
import Text from '../../src/components/typography';
import MapPin from '../../src/components/ui/MapPin';
import ContactDetails from '../../src/containers/Contact/ContactDetails'
import {Links} from '../../src/components/ui';

// icons
import chevronLeft from '../../src/assets/icons/chevron-left-white.svg';

// other 
import googleMapStyle from '../../src/themes/google-map.json';
import AvailableStock from '../../src/components/multimedia/AvailableStock';


const Content = styled.div`
  margin: 40px 0 20px;

  ${theme.breakpoints.up('md')} {
    margin: 40px 0 60px;
  }

  ${theme.breakpoints.up('lg')} {
    margin: 40px 0 120px;
  }
`


const ContentContainer = styled.div`
  max-width: 580px;
  margin: 0 auto;

  h4 {
    font-size: 22px;
  }
`

const ContentGrid = styled(Grid)`
  ${theme.breakpoints.up('lg')} {
    flex-direction: row-reverse;
  }
`

const ContactDetailsContainer = styled.div`
  h6 {
    font-size: 22px;
  }
`

const GoogleMapContainer = styled.div`
  width: 100%;
  height: 268px;
  margin-bottom: 50px;

  ${theme.breakpoints.up('md')} {
    height: 400px;
  }

  ${theme.breakpoints.up('lg')} {
    height: 700px;
    padding-left: 30px;
    margin-bottom: 0;
  }
`

const GoogleMapBorder = styled.div`
  height: 100%;

`

const ReturnLink = styled.div`
	margin: 20px auto 0;
	padding-right: 20px; 
  max-width: 610px;
  text-align: left;
  padding: 0 ${theme.containers.main.gutter};

  ${theme.breakpoints.up('md')} {
    margin-top: 40px;
  }

  ${theme.breakpoints.up('lg')} {
    max-width: 100%;
  }
` 

const Wrapper = styled.div`
  max-width: 1300px;
  margin: 0 auto;
`

const googleMapKey = process.env.GOOGLE_MAPS_API_KEY || 'AIzaSyDvDPE1nXC0ejI_nWsFYf37isGY_XfJCp4'

const Dealer = (props) => {
  const {
    data,
  } = props

  const [backLink, setBackLink] = useState(get(data, 'sales', null) ? '/find-a-dealer' : '/find-a-service-centre')

  useEffect(() => {
    if (get(props, 'router.asPath', '').indexOf('service') !== -1) {
      setBackLink('/find-a-service-centre')
    } else {
      setBackLink('/find-a-dealer')
    }
    

    // This will only happen in preview mode (when domain isn't available in getStaticPaths)
    if (props.redirect) {
      // To prevent any slow routing on development
      window.location.href = '/404'
    }
  }, [])

    // Add Google Schema Mark up to dealer pages for AU and NZ sites
    const businessSchema = {
      "@context": "https://schema.org",
      "@type": "AutoDealer",
      "name": props.meta?.title && props.meta.title,
      "address": {
        "@type": "PostalAddress",
        "streetAddress": data?.contact?.addressLine1 && data.contact.addressLine1,
        "addressLocality": data?.contact?.suburb && data.contact.suburb,
        "addressRegion": data?.contact?.state && data.contact.state,
        "postalCode": data?.contact?.postcode && data.contact.postcode,
        "addressCountry": props.countryProps?.countryCode && props.countryProps.countryCode
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": data?.location?.lat && data.location.lat,
        "longitude": data?.location?.lng && data.location.lng
      },
      "url": `https://${props.countryProps.countryCode.toLowerCase() === 'au' ? 'jayco.com.au' : 'jayco.co.nz'}${props.router.asPath}`,
      "telephone": data?.contact?.phone && data.contact.phone
    }


  const stockCta = get(data, 'contact.website', null) ? {
    cta: {
      href: `${data.contact.website}/stock`,
      target: '_blank',
      title: props.dealerName ? `View all ${props.dealerName} Stock` : `View all dealer Stock`
    }
  } : {};

  return (
  	<div>
      {process.env.DEALER_SITE !== true &&
        <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(businessSchema)}} />
      }
      {props.heroBanner &&
        <Banner
          {...props.heroBanner}
          largePaddingTop={true}
        />
      }
      <Wrapper>
        {/* <Grid container spacing={0} direction={'row'} align={'right'}>
          <Grid item xs={12}>
            <ReturnLink>
              <Links href={backLink} svg={chevronLeft}>
                Go back
              </Links>
            </ReturnLink>
          </Grid>
        </Grid> */}
        {data &&
        <Content>
          <ContentGrid container spacing={0} className="hasPadding" direction={'row'} justify={'space-between'} align={'left'}>
          {googleMapKey &&
              <Grid item xs={12} lg={7}>
                <Box px={2}>
                  <GoogleMapContainer>
                    <GoogleMapBorder>
                      <GoogleMapReact
                        bootstrapURLKeys={{ key: googleMapKey }}
                        defaultCenter={data.location}
                        defaultZoom={15}
                        options={{
                          styles: googleMapStyle
                        }}
                        >
                        <MapPin
                          {...data.location}
                        />
                      </GoogleMapReact>
                    </GoogleMapBorder>
                  </GoogleMapContainer>
                </Box>
              </Grid>
            }
            <Grid item xs={12} lg={5}>
              <Box px={2}>
                <ContentContainer>
                  {data.text &&
                    <>
                      <Text variant="h4" colour="black">{props.dealerName}</Text>
                      <Text variant="body1">{ReactHtmlParser(data.text)}</Text>
                    </>
                  }
                  <ContactDetailsContainer>
                    <ContactDetails 
                      title="Contact details"
                      dealer={props.dealerName}
                      stack={true}
                      data={{
                        ...data,
                        text: undefined
                      }}
                    />
                  </ContactDetailsContainer>
                </ContentContainer>
              </Box>
            </Grid>
            
          </ContentGrid>
        </Content>
        }
      </Wrapper>
      {(props.countryProps && props.countryProps.countryCode.toLowerCase() === 'au') &&
        <div>
          <AvailableStock 
            countryProps={props.countryProps}
            dealerId={data.id}
            {...stockCta}
            rates={props.rates}
            // cta={{
            //   href: 
            // }}
          />
        </div>
      }
    </div>
  )
}
  
Dealer.propTypes = {
}
  
Dealer.defaultProps = {
}

export async function getStaticPaths() {

  const GET_DEALERS = gql`
    query GET_DEALERS {
      dealers(first: 1000) {
        nodes {
          uri
          acf_domains {
            assignedDomains
          }
        }
      }
    }
  `

  const result = await client.query({
    query: GET_DEALERS,
  });

  const pagesArr = get(result, 'data.dealers.nodes', null);
  let paths = [];

  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();
  const domain = countryCode === 'au' ? 'jayco.com.au' : 'jayco.co.nz';

  pagesArr.forEach(item => {
    const uri = get(item, 'uri', null);
    const assignedDomains = get(item, 'acf_domains.assignedDomains', []);

    assignedDomains.indexOf(domain) !== -1 && paths.push({
      params: {
        id: uri.replace('-ccau', '').replace('-ccnz', '').replace(`-au-dealers`, '').replace(`-nz-dealers`, '')
      }
    })
  })

  return { paths, fallback: false }
}

export async function getStaticProps(context) {

  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();

  const GET_DEALER = gql`
    query GET_DEALER($uri: String) {
      pageBy(uri: "find-a-dealer") {
        ${contentBuilderQuery()}
      }
      ${financeRatesQuery}
      dealerBy(uri: $uri) {
        id
        dealerId
        title
        seo {
          ${seoQuery}
        }
        acf_domains {
          assignedDomains
        }
        acf_dealers {
          dealerID
          addressLine1
          addressLine2
          accessoriesEmail
          dealerAboutUs
          country
          website
          suburb
          state
          serviceEmail
          salesEmail
          service
          sales
          postcode
          phone
          partsEmail
          parts
          openingHours
          mainEmail
          latitude
          longitude
        }
      }
    }
  `
  const result = await client.query({
    query: GET_DEALER,
    variables: {
      uri: `${context.params.id}?${countryCode}`
    }
  });

  const title = get(result, 'data.dealerBy.title', null);
  var seo = get(result, 'data.dealerBy.seo', null);
  if (seo.canonical) {
    var canonicalParts = seo.canonical.split('/');
    canonicalParts[canonicalParts.length-1] = context.params.id;
    seo.canonical = canonicalParts.join('/');
  }

  const cbData = get(result, 'data.pageBy.acf_content_builder.contentBuilder', null);
  const dealerName = get(result, 'data.dealerBy.title', null);

  if (!get(result, 'data.dealerBy', null)) {
    return {
      props: {
        redirect: true
      }
    }
  }

  const dealerData = get(result, 'data.dealerBy', {})
  const data = refactorDealerData(dealerData);
  const rates = financeRatesRestructure(result, countryCode);

  // Hero banner
  const hasBanner = get(cbData, '[0].fieldGroupName', '') === 'page_AcfContentBuilder_ContentBuilder_FcSingleHeroBanner';
  const heroBanner = hasBanner ? refactorHb(cbData[0]) : null;
  const assignedDomains = get(result, 'data.dealerBy.acf_domains.assignedDomains', []); 

  // breadcrumbs
  const dealerUrl = get(context, 'params.id', false) ? '/dealer/' + context.params.id : false;
  const breadcrumbs = dealerUrl ? await refactorBreadcrumbsData(dealerUrl, assignedDomains) : null;
  
  const updatedHeroBannerData = dealerName ? {
    ...heroBanner,
    mainHeading: dealerName
  } : heroBanner;

  return {
    props: {
      meta: {
        title,
        seo,
        assignedDomains
      },
      breadcrumbs,
      heroBanner: updatedHeroBannerData,
      dealerName: ReactHtmlParser(dealerName),
      data,
      rates
    }
  }
}
  
export default Dealer